// Custom Cursor Script
document.addEventListener("DOMContentLoaded", function () {
  // Selectors
  const $bigBall = document.querySelector('.cursor__ball--big');
  const $smallBall = document.querySelector('.cursor__ball--small');
  const $hoverables = document.querySelectorAll('a, button');

  // Check if required elements exist
  if (!$bigBall || !$smallBall) {
    console.error("Cursor elements not found. Ensure '.cursor__ball--big' and '.cursor__ball--small' exist in your HTML.");
    return;
  }

  if (typeof TweenMax === 'undefined') {
    console.error("TweenMax library not found. Ensure GSAP is loaded correctly.");
    return;
  }

  // Listeners
  document.body.addEventListener('mousemove', onMouseMove);
  $hoverables.forEach(item => {
    item.addEventListener('mouseenter', onMouseHover);
    item.addEventListener('mouseleave', onMouseHoverOut);
  });

  // Move the cursor
  function onMouseMove(e) {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    TweenMax.to($bigBall, 0.4, {
      x: e.pageX - 10,
      y: e.pageY - 10 - scrollY
    });
    TweenMax.to($smallBall, 0.1, {
      x: e.pageX - 5,
      y: e.pageY - 7 - scrollY
    });
  }

  // Hover an element
  function onMouseHover() {
    TweenMax.to($bigBall, 0.3, {
      scale: 1.5
    });
  }

  function onMouseHoverOut() {
    TweenMax.to($bigBall, 0.3, {
      scale: 1
    });
  }
});
